var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppBar, Grid, styled, Toolbar } from "@mui/material";
// Media imports
//---------------------------------------------------------------------------------------------------
// ## MUI STYLED ##
var StyledAppBar = styled(AppBar)(function () { return ({
    padding: "10px 5px",
    boxShadow: "none",
}); });
//---------------------------------------------------------------------------------------------------
// ## COMPONENTS ##
// VTNavBar use for web development to replace the material ui appBar
export default function VTNavBar(_a) {
    var sx = _a.sx, primaryArea = _a.primaryArea, onClick = _a.onClick, home = _a.home, altArea = _a.altArea;
    //-------------------------------------------------------------------------------------------------
    // ## Render ##
    // Navigation bar
    return (_jsx(StyledAppBar, __assign({ position: "static", sx: __assign({ zIndex: 10000 }, sx) }, { children: _jsx(Toolbar, __assign({ variant: "dense" }, { children: _jsxs(Grid, __assign({ container: true, justifyContent: "flex-start" }, { children: [home && (_jsx(Grid, __assign({ container: true, item: true, alignItems: "center", xs: 1, justifyContent: "center" }, { children: home }))), primaryArea && (_jsx(Grid, __assign({ item: true, container: true, xs: altArea ? 6 : home ? 11 : 12, alignContent: "center" }, { children: primaryArea }))), altArea && (_jsx(Grid, __assign({ item: true, container: true, xs: primaryArea ? (home ? 5 : 6) : home ? 11 : 12, justifyContent: "flex-end", alignItems: "center" }, { children: altArea })))] })) })) })));
}
